import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('Updates')

/** 👇 View edu */
const ViewUpdates = () => analytics({
  label: GenerateLabel({}),
  action: 'Updates - view edu',
  name: 'view_updates',
});

/** 👇 users click category,
 * category = 'all,keuangan,insight,psikologi trading,tutorial,pemula,seminar,manajemen riskiko,teknikal,fundamental'
 */
const ClickCategoryUpdates = ({ category = '' }) => analytics({
  label: GenerateLabel({ category }),
  action: 'Updates - click category',
  name: 'click_category_updates',
});

/** 👇 users click search */
const ClickSearchUpdates = () => analytics({
  label: GenerateLabel({}),
  action: 'Updates - click search',
  name: 'click_search_updates',
});

/** 👇 users search enter */
const EnterSearchUpdates = () => analytics({
  label: GenerateLabel({}),
  action: 'Updates - search enter',
  name: 'enter_search_updates',
});

/** 👇 users click filter */
const ClickFilterUpdates = () => analytics({
  label: GenerateLabel({}),
  action: 'Updates - click filter',
  name: 'click_filter_updates',
});

/** 👇 users click filter ok,
 * posted = 'today/yesterday/last 7 days/last 14 days/last 30 days'
 * type = 'video, artikel'
 */
const FilterUpdates = ({
  posted = '',
  type = 'video, artikel',
}) => analytics({
  label: GenerateLabel({ type, posted }),
  action: 'Updates - click filter ok',
  name: 'filter_updates',
});

/** 👇 users click content,
 * contentCategory = 'blog/insight/seminar/dll'
 * contentType = 'video, artikel'
 */
const ClickContentUpdates = ({
  contentTitle = '',
  contentCategory = '',
  contentType = 'video, artikel',
}) => analytics({
  label: GenerateLabel({ contentCategory, contentType, contentTitle }),
  action: 'Updates - click content',
  name: 'click_content_updates',
});

const Updates = {
  ViewUpdates,
  ClickCategoryUpdates,
  ClickSearchUpdates,
  EnterSearchUpdates,
  ClickFilterUpdates,
  FilterUpdates,
  ClickContentUpdates,
};

export default Updates;
